import PropTypes from 'prop-types';
import React from 'react';

import Railcard from '../../../records/Railcard';

export default function RailcardBadge ({ railcard }) {
    return (
        <span className={ `fare__railcard-badge fare__railcard-badge--${railcard.code.toLowerCase()} text-sm` }>
            { railcard.name }
        </span>
    );
}

RailcardBadge.propTypes = {
    railcard: PropTypes.instanceOf(Railcard).isRequired
};
